module.exports = __webpack_public_path__ + "img/linkedin.d92270f8.svg";